import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { BriefingsSection } from "@/features/dashboard/BriefingsSection";

function BriefingsTab() {
  const navigate = useNavigate();
  return <BriefingsSection onConnect={() => void navigate({ to: "/settings/connectors" })} />;
}

export const Route = createFileRoute("/_auth/_agents/briefings/")({
  component: BriefingsTab,
});
